import type { PropsWithChildren } from 'react';
import React from 'react';

import { ConfirmationModalContext } from './ConfirmationModalContext';
import useConfirmationModal from './hooks/useConfirmationModal';
import ConfirmationModal from './ConfirmationModal';

function ConfirmationModalContextProvider({ children }: PropsWithChildren) {
  const confirmationModal = useConfirmationModal();

  return (
    <ConfirmationModalContext.Provider value={confirmationModal}>
      {children}
      <ConfirmationModal {...confirmationModal} />
    </ConfirmationModalContext.Provider>
  );
}

export default ConfirmationModalContextProvider;
